export function statusLabel(status: string): string {
  if (status === 'rerun_queued') return 'queued for re-run';
  return status;
}

export function dotClass(status: string): string {
  switch (status) {
    case 'done':      return 'dot dot-ok';
    case 'running':   return 'dot dot-run';
    case 'failed':    return 'dot dot-err';
    case 'warning':
    case 'paused':
    case 'rerun_queued':
    case 'skipped':   return 'dot dot-warn';
    case 'queued':
    case 'pending':   return 'dot dot-dim';
    default:          return 'dot dot-dim';
  }
}
